export default "__VITE_ASSET__BaK5sxOZ__"